// Seleção do contrato ativo no workspace (flows/contrato.md R1).

/** Sentinela de "Novo": o seletor de modo abre vazio em vez de herdar o contrato anterior. */
export const NEW_CONTRACT = "new";

export function resolveActiveContract<T extends { id: string }>(
  contracts: T[],
  selectedId: string | null,
): T | null {
  if (selectedId === NEW_CONTRACT) return null;
  if (selectedId) return contracts.find((c) => c.id === selectedId) ?? contracts[0] ?? null;
  return contracts[0] ?? null;
}
